import {
  detectMonthAndYear,
  getCurrentDay,
  getCurrentMonth,
  getCurrentYear,
} from '@/shared/components/Datepicker/Datepicker.utils';
import { create } from 'zustand';
import { DatepickerStore } from './DatepickerStore.consts';
import { stringifyDate } from '@/shared/utils/datepicker';
import { DAY_TYPE } from '@/shared/components/Datepicker/Datepicker.consts';

export const useDatepickerStore = create<DatepickerStore>((set, get) => ({
  month: getCurrentMonth(),
  year: getCurrentYear(),
  isOpen: false,
  setIsOpen: (isOpen: boolean) => {
    set((state) => ({ ...state, isOpen }));
  },
  setDay: (day: number) => {
    set((state) => ({
      ...state,
      day,
    }));
  },
  isCurrentDay: (day: number) => {
    const { month, year } = get();
    return getCurrentDay() === day && getCurrentMonth() === month && getCurrentYear() === year;
  },
  setMonth: (month: number) => {
    set((state) => ({ ...state, month }));
  },
  setYear: (year: number) => {
    set((state) => ({ ...state, year }));
  },
  setDateByDayType: (day: number, dayType: DAY_TYPE) => {
    const { month, year } = detectMonthAndYear(dayType, get().month, get().year);
    set((state) => ({ ...state, day, month, year }));
  },
  setDateFromString: (dateString: string) => {
    const date = new Date(dateString);
    set((state) => ({
      ...state,
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    }));
  },
  clearDate: () => {
    set((state) => ({
      ...state,
      day: undefined,
      month: getCurrentMonth(),
      year: getCurrentYear(),
    }));
  },
  getSelectedDate: (): string => {
    const { day, month, year } = get();
    return stringifyDate(day, month, year);
  },
}));
